import { useState } from 'react'

const navLinks = [
  { id: 'front-row', label: '前排热瓜' },
  { id: 'follow-up', label: '蹲一个后续' },
  { id: 'collections', label: '围观合集' },
  { id: 'discussion', label: '群众讨论' },
  { id: 'subscribe', label: '蹲守订阅' },
]

export default function SiteNav() {
  const [open, setOpen] = useState(false)
  const [keyword, setKeyword] = useState('')

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-[1240px] items-center gap-4 px-4 md:h-[68px] md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg font-heading font-bold text-background-50">
            5
          </span>
          <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
            51<span className="text-primary-500">.cg</span>
          </span>
          <span className="hidden items-center rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900 sm:flex">
            群众围观站
          </span>
        </a>

        <nav className="ml-2 hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto hidden items-center gap-3 md:flex">
          <div className="flex h-10 w-52 items-center gap-2 rounded-md border border-background-300/80 bg-background-100/70 px-3">
            <i className="ri-search-line text-base text-foreground-500"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜一个正在蹲的话题"
              className="h-full w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
            />
          </div>
          <a
            href="#subscribe"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            蹲守订阅
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-300/80 text-foreground-800 cursor-pointer lg:hidden"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-2-line text-xl'}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 lg:hidden">
          <div className="flex flex-wrap gap-2">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="rounded-full border border-background-300/80 px-4 py-2 text-sm text-foreground-800 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </div>
          <a
            href="#subscribe"
            onClick={() => setOpen(false)}
            className="mt-3 flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 cursor-pointer"
          >
            蹲守订阅
          </a>
        </div>
      )}
    </header>
  )
}